import { render, staticRenderFns } from "./CreateTextContent.vue?vue&type=template&id=efd13fe8"
import script from "./CreateTextContent.vue?vue&type=script&lang=js"
export * from "./CreateTextContent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports